import { ResizableModule } from 'angular-resizable-element';

import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';

import { SnCommonModule } from '@lib/common';
import { SnButtonModule } from '@lib/ui/button';
import { SnDataListModule } from '@lib/ui/data-list';
import { FsDragBarModule } from '@lib/ui/drag-bar';
import { SnIconModule } from 'libs/ui/icon/src/lib/icon.module';
import { AxonNotificationIconService } from './services/axon-notification-icon.service';

import { AxonDevicePopupComponent } from './components';
import { AxonCamFeedCardComponent } from './components/axon-cam-feed-card/axon-cam-feed-card.component';
import { AxonDevicePopoutComponent } from './components/axon-device-popout/axon-device-popout.component';
import { AxonLivestreamIframeComponent } from './components/axon-livestream-iframe/axon-livestream-iframe.component';
import { AxonLoginToastComponent } from './components/axon-login-toast/axon-login-toast.component';
import { AxonNotificationDetailsComponent } from './components/axon-notification-details/axon-notification-details.component';
import { AxonNotificationDialogComponent } from './components/axon-notification-dialog/axon-notification-dialog.component';
import { AxonNotificationIconComponent } from './components/axon-notification-icon/axon-notification-icon.component';
import { AxonWelcomeModalWrapperComponent } from './components/axon-welcome-modal-wrapper/axon-welcome-modal-wrapper.component';
import { AxonWelcomeModalComponent } from './components/axon-welcome-modal/axon-welcome-modal.component';

@NgModule({
  imports: [
    CommonModule,
    SnButtonModule,
    MatDialogModule,
    DragDropModule,
    MatButtonModule,
    SnIconModule,
    MatMenuModule,
    MatDialogModule,
    MatTooltipModule,
    SnCommonModule,
    ResizableModule,
    SnDataListModule,
    FsDragBarModule,
  ],
  exports: [
    AxonDevicePopoutComponent,
    AxonDevicePopupComponent,
    AxonCamFeedCardComponent,
    AxonLivestreamIframeComponent,
    AxonNotificationIconComponent,
    AxonNotificationDetailsComponent,
    AxonWelcomeModalWrapperComponent,
  ],
  declarations: [
    AxonDevicePopoutComponent,
    AxonDevicePopupComponent,
    AxonCamFeedCardComponent,
    AxonLivestreamIframeComponent,
    AxonNotificationIconComponent,
    AxonNotificationDetailsComponent,
    AxonNotificationDialogComponent,
    AxonWelcomeModalComponent,
    AxonWelcomeModalWrapperComponent,
    AxonLoginToastComponent,
  ],
  providers: [
    AxonNotificationIconService,
  ],
})
export class AxonModule {}
